import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { HashLoader } from "react-spinners";
import Box from "@mui/material/Box";

import { useEffect, useState } from "react";
import { CustomerProfile } from "../CustomerProfile/CustomerProfile";
import { ICONS } from "../../utils/icons";
import { getAllCustomers } from "../../api/customers";
import { COLORS } from "../../utils/colors";

export const Customers = ({
  eventID,
  numberOfTickets,
  userData,
  handleSnackbar,
}) => {
  const [customerProfile, setCustomerProfile] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [customersObject, setCustomersObject] = useState(null);

  useEffect(async () => {
    try {
      setLoading(true);

      const { data, error, status } = await getAllCustomers({
        eventID,
        apiKey: userData.operators[0].api_key,
      });

      if (error) {
        console.log(error);
        if (!error.message.includes("No customer found")) {
          handleSnackbar(error.message, "error");
        }
        setLoading(false);
        return;
      }

      if (status === 200) {
        setCustomers(data);
        processDataGridData(data);
      }

      setLoading(false);
    } catch (error) {
      console.log(error);
      handleSnackbar("Error fetching customers", "error");
      setLoading(false);
    }
  }, []);

  const processDataGridData = (data) => {
    const array = [];
    const extraFieldsSet = new Set();

    // Gather all unique extra field keys
    data.forEach((customer) => {
      if (customer.extra_fields) {
        Object.keys(customer.extra_fields).forEach((key) => {
          extraFieldsSet.add(key);
        });
      }
    });

    // Convert the set to an array and map to column definitions
    const extraFieldsColumns = Array.from(extraFieldsSet).map((field) => ({
      headerName: "Extra field: " + field.replace(/_/g, " "),
      field: field,
      flex: 1,
    }));

    // Define the fixed columns
    const columns = [
      { headerName: "ID", field: "id", flex: 1 },
      { headerName: "Email", field: "email", flex: 1 },
      { headerName: "Account Status", field: "status", flex: 1 },
      { headerName: "First Name", field: "first_name", flex: 1 },
      { headerName: "Last Name", field: "last_name", flex: 1 },
      { headerName: "Title", field: "title", flex: 1 },
      ...extraFieldsColumns, // Add the extra fields columns
    ];

    data.forEach((customer, index) => {
      const customerData = {
        ...customer,
        index: index + 1,
        id: customer._id.slice(19, 24),
      };

      // Add extra fields to the customer data
      if (customer.extra_fields) {
        Object.keys(customer.extra_fields).forEach((key) => {
          customerData[key] = customer.extra_fields[key];
        });
      }

      array.push(customerData);
    });

    setCustomersObject({
      columns: columns,
      rows: array,
    });
  };

  const handleClick = (ticket) => {
    // setTicket(ticket);
    // setTicketDialog(true);
  };

  return (
    <div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: "15px",
          margin: "25px 0px",
        }}
      >
        <div className="small-container">
          <div
            className="container-row"
            style={{
              width: "-webkit-fill-container",
              justifyContent: "space-between",
            }}
          >
            <p id="subheader">Total purchases</p>
            {ICONS.moneyAccent20}
          </div>
          <h2 style={{ fontSize: "34px", margin: "10px 0 0 0" }}>
            {numberOfTickets}
          </h2>
        </div>
        <div className="small-container">
          <div
            className="container-row"
            style={{
              width: "-webkit-fill-container",
              justifyContent: "space-between",
            }}
          >
            <p id="subheader">Different customers (on this page)</p>
            {ICONS.peopleArrowsAccent20}
          </div>
          <h2 style={{ fontSize: "34px", margin: "10px 0 0 0" }}>
            {customers?.length}
          </h2>
        </div>
        <div className="small-container">
          <div
            className="container-row"
            style={{
              width: "-webkit-fill-container",
              justifyContent: "space-between",
            }}
          >
            <p id="subheader">Avg. tickets bought per customer</p>
            {ICONS.scaleAccent20}
          </div>
          <h2 style={{ fontSize: "34px", margin: "10px 0 0 0" }}>
            {customers?.length === 0
              ? 0
              : Math.round((numberOfTickets / customers?.length) * 100) / 100}
          </h2>
        </div>
      </div>
      {loading && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "300px",
          }}
        >
          <HashLoader color={COLORS.mainAccent} />
        </div>
      )}
      {customersObject && (
        <Box sx={{ height: 720, width: "100%" }}>
          <DataGrid
            {...customersObject}
            slots={{ toolbar: GridToolbar }}
            onCellClick={(e) => handleClick(e.row)}
            slotProps={{
              columnMenu: {
                background: "red",
                counter: customersObject.rows.length,
              },
            }}
            style={{ fontFamily: "AuthenticSans90", marginBottom: "40px" }}
            sx={{
              "& .MuiDataGrid-toolbarContainer": {
                "& .MuiButton-text": {
                  color: COLORS.mainAccent,
                  textTransform: "capitalize",
                  fontFamily: "AuthenticSans90",
                  fontSize: "14px",
                },
              },
            }}
          />
        </Box>
      )}
      <div style={{ height: "50px" }} />
      {customerProfile && (
        <CustomerProfile
          setCustomerProfile={setCustomerProfile}
          eventID={eventID}
        />
      )}
    </div>
  );
};
